import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToScale() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="20235" id="property-transformation-cta" ref={ref} className="dark bg-gradient-to-br from-[#1ccb5d] to-[#0e301a] text-white py-24 px-4 relative overflow-hidden flex flex-col items-center justify-center text-center">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,_transparent_0%,_rgba(0,0,0,0.3)_100%)] pointer-events-none" />
      
      <div className={cn("relative z-10 max-w-4xl mx-auto space-y-8 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <h2 className="text-4xl md:text-5xl lg:text-[64px] font-extrabold tracking-tighter text-white drop-shadow-xl font-sans leading-tight">
          Want Your Lawn Looking Its Best?
        </h2>
        
        <p className="text-lg md:text-[20px] text-white/90 max-w-2xl mx-auto leading-relaxed font-medium">
          Experience the gold standard in property maintenance. Our expert team delivers immaculate results for homes and businesses across the Central Coast.
        </p>

        <div className="pt-6">
          <Link to="/ContactPage">
            <Button size="lg" className={cn("h-16 px-12 text-xl font-extrabold rounded-full", "bg-white text-[#0a0f14] border-none", "hover:bg-white/95 hover:scale-105 transition-all duration-300", "shadow-2xl hover:shadow-white/20 relative overflow-hidden group")}>
              Request a Quote
              <ArrowRight className="ml-2 size-6 group-hover:translate-x-1 transition-transform" />
              {}
              <div className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 -translate-x-full group-hover:animate-[shine_3s_infinite]" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}